import { useState } from "react";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import { FaBackward } from "react-icons/fa";
import Logo from "../assest/tactosnew.png";
import { startupLogin } from "../utils/api";
import { useDispatch } from 'react-redux';
import { setLogoUrl } from '../utils/logoSlice';
import { useAuth } from "../utils/authContext";
import StartupRegPricing from "../components/StartupRegPricing";
import { toast } from "react-hot-toast"
import axios from "axios"

const Loginnew = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [isCoFounder, setIsCoFounder] = useState(false);

  const [showPaymentModal, setShowPaymentModal] = useState(false)

  const { loginStartup } = useAuth();
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess(false);

    try {
      const data = await startupLogin(email, password);

      console.log("Login response data:", data);
      if (data.startup.status === "Active") {
              localStorage.clear()
        localStorage.setItem("startupId", data.startup.id);
        localStorage.setItem("fullName", data.startup.fullName);
        localStorage.setItem("startupName", data.startup.startupName);
        localStorage.setItem("logoUrl", data.startup.logo);
        localStorage.setItem("email", data.startup.email);
        localStorage.setItem("userPhone", data.startup.phone);

        dispatch(setLogoUrl(data.startup.logo));

        loginStartup(data.token);
        setSuccess(true);
        setTimeout(() => navigate("/startup-dashboard"), 1500);

      } else if (data.startup.status === "hold" || data.startup.paymentStatus === "Unpaid") {
      localStorage.clear()
        localStorage.setItem("startupId", data.startup.id);
        localStorage.setItem("fullName", data.startup.fullName);
        localStorage.setItem("email", data.startup.email);
        localStorage.setItem("userPhone", data.startup.phone);

        setError("⚠️ Your account is not activated yet. Please complete your payment to activate it.");
        setShowPaymentModal(true);

      } else {
        setError("⚠️ Your account is not activated yet. Please wait for approval.");
      }

    } catch (err) {
      console.log(err.message);
      setError(err.message || "Something went wrong. Please try again later.");
    }
  };

  const handleToggle = () => {
    setIsCoFounder((prev) => !prev);
    if (!isCoFounder) navigate("/cofounder-login");
  };

  const handlePaymentModalClose = async () => {
    try {
      const startupId = localStorage.getItem("startupId");
      const token = localStorage.getItem("Startuptoken");

      if (startupId) {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/startups/unpaid/${startupId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        localStorage.removeItem("startupId");
        localStorage.removeItem("Startuptoken");
      }

      setShowPaymentModal(false);
      setLoading(false);
    } catch (error) {
      console.error("Error cleaning up unpaid registration:", error);
      toast.error("Failed to clean up registration. Please contact support.");
    }
  };

  return (
    <div className="relative w-full h-[100dvh] lg:h-screen bg-gradient-to-br from-red-500 via-red-300 to-yellow-100 flex items-center justify-center p-4 overflow-hidden">
      {/* Logo */}
      <div className="absolute top-10 left-10">
        <Link to="/">
          <img src={Logo} alt="Tactos Logo" className="w-28" />
        </Link>
      </div>

      {/* Auth Card */}
      <div className="w-full h-full bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col md:flex-row">
        <div className="md:w-1/2 w-full px-8 py-6 h-full flex flex-col justify-center items-center">
          <h2 className="text-3xl font-bold text-center text-gray-800 mt-4 mb-6">
            Welcome Back
          </h2>

          {success ? (
            <div className="text-center mt-6">
              <h3 className="text-2xl font-semibold text-green-600 mb-4">
                🎉 Login Successful!
              </h3>
              <p className="text-gray-600 mb-4">
                Redirecting to your dashboard...
              </p>
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              className="space-y-5 text-sm w-full lg:w-1/2 mx-auto"
            >
              {error && (
                <motion.div
                  initial={{ y: -10, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.2 }}
                  className="bg-red-100 text-red-700 p-3 rounded text-sm"
                >
                  {error}
                </motion.div>
              )}

              <div className="flex flex-col">
                <label
                  htmlFor="email"
                  className="text-gray-700 font-medium mb-1"
                >
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                  placeholder="Your Email"
                />
              </div>

              <div className="flex flex-col">
                <div className="flex justify-between items-center mb-1">
                  <label htmlFor="password" className="text-gray-700 font-medium">
                    Password
                  </label>
                  <Link
                    to="/forgot-password"
                    className="text-xs text-indigo-600 hover:underline"
                  >
                    Forgot password?
                  </Link>
                </div>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-gray-200 placeholder-gray-500 rounded-full px-4 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-300 border-none"
                  placeholder="Your Password"
                />
              </div>
              <button
                type="submit"
                className="w-full px-6 py-2 bg-[#4b154c] text-white rounded-full hover:bg-purple-700 text-sm"
              >
                Login
              </button>

              <div className="flex justify-center mb-1 text-gray-600 text-sm">
                Don't have an account?{" "}
                <Link
                  to="/startup-reg"
                  className="text-indigo-600 hover:underline ml-1"
                >
                  Sign up
                </Link>
              </div>

           

            </form>
          )}
        </div>

        <div className="md:w-1/2 hidden lg:block relative overflow-hidden">
          <img
            src="/login_img.jpg"
            alt="Startup Illustration"
            className="w-full lg:h-full object-cover"
          />
          <Link
            to="/"
            className="absolute top-4 right-4 flex items-center gap-2 text-black font-bold"
          >
            <FaBackward /> Back to Home
          </Link>
        </div>
      </div>

      {showPaymentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Complete Your Registration</h3>
              <button
                onClick={handlePaymentModalClose}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            </div>

            <div className="mb-6">
              <p className="text-gray-700 mb-4">
                Please select a membership plan to complete your startup registration.
                Your registration will be cancelled if you close this window without payment.
              </p>

              <StartupRegPricing
                onPlanSelect={async (plan) => {
                  try {
                    setPaymentProcessing(true);
                    await handlePaymentComplete(plan);
                  } catch (error) {
                    console.error('Payment Error:', error);
                    toast.error(error.message || 'Payment processing failed');
                  } finally {
                    setPaymentProcessing(false);
                  }
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Loginnew;
